import React from 'react';
import { FastForward } from 'lucide-react';
import { Button } from '../ui/Button';
import { cn } from '../../utils/cn';

interface SkipButtonProps {
  onSkip: () => void;
  disabled?: boolean;
  className?: string;
}

export const SkipButton: React.FC<SkipButtonProps> = ({
  onSkip,
  disabled = false,
  className
}) => {
  return (
    <Button
      variant="outline"
      onClick={onSkip}
      disabled={disabled}
      className={cn(
        'w-full mobile-touch-target',
        'border-yellow-400 dark:border-yellow-600',
        'bg-yellow-500 dark:bg-yellow-600',
        'text-white dark:text-gray-900',
        'hover:bg-yellow-600 dark:hover:bg-yellow-700',
        'hover:border-yellow-500 dark:hover:border-yellow-700',
        'transition-colors duration-200 ease-theme',
        className
      )}
      aria-label="Skip this guess"
    >
      <FastForward className="w-4 h-4 mr-2" />
      Skip
    </Button>
  );
};
